export const VERSION = {
  PROD: 'V. 3.8.1',
  QA: 'V. 5.3.1 (QA)',
}
